enum BILL_TYPE {
  BILL = 'F',
  CREDIT = 'A',
  BRM = 'B',
}
export default BILL_TYPE

export enum ANNEXE_TYPE {
  INTERVENTION = 'intervention',
  PESEES = 'pesees',
}
